var exports = {};

exports = function isOpera(ua) {
  ua = ua || window.navigator.userAgent;
  return ua.indexOf("OPR/") !== -1 || ua.indexOf("Opera/") !== -1 || ua.indexOf("OPT/") !== -1;
};

export default exports;